<template>
  <section class="section tg-section">
    <div class="container">
      <div class="tg-layout">
        <div class="tg-layout__content">
          <span class="section__label">Telegram candb</span>
          <h2 class="section__title">Управляйте задачами прямо в Telegram</h2>
          <p class="tg-section__subtitle">
            Чат-бот candb позволяет создавать категории, проекты и задачи прямо из мессенджера —
            без переключений между приложениями.
          </p>
          <ul class="tg-features">
            <li v-for="f in features" :key="f.title" class="tg-feature">
              <div class="tg-feature__icon">
                <ui-icon :name="f.icon" :size="20" />
              </div>
              <div class="tg-feature__body">
                <strong class="tg-feature__title">{{ f.title }}</strong>
                <p class="tg-feature__text">{{ f.text }}</p>
              </div>
            </li>
          </ul>
          <a href="https://t.me/candbpro" target="_blank" rel="noopener" class="tg-channel">
            <ui-icon name="send" :size="18" />
            <span>Канал в Telegram: разборы системы изнутри</span>
          </a>
        </div>
        <div class="tg-layout__visual">
          <div class="tg-chat">
            <div class="tg-chat__header">
              <div class="tg-chat__avatar">
                <ui-icon name="message-circle" :size="18" />
              </div>
              <div class="tg-chat__info">
                <span class="tg-chat__name">candb</span>
                <span class="tg-chat__status">bot</span>
              </div>
            </div>
            <div class="tg-chat__body">
              <div v-for="msg in messages" :key="msg.id"
                class="tg-chat__bubble"
                :class="msg.from === 'user' ? 'tg-chat__bubble--user' : 'tg-chat__bubble--bot'"
              >{{ msg.text }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import UiIcon from '../ui/UiIcon.vue'
export default {
  name: 'TelegramSection',
  components: { UiIcon },
  data() {
    return {
      features: [
        {
          icon: 'folder',
          title: 'Категории',
          text: 'Создавайте категории для группировки проектов одной командой.',
        },
        {
          icon: 'bar-chart',
          title: 'Проекты',
          text: 'Добавляйте проекты в нужную категорию прямо из чата.',
        },
        {
          icon: 'clipboard-list',
          title: 'Задачи',
          text: 'Ставьте задачи и назначайте исполнителей за несколько секунд.',
        },
        {
          icon: 'zap',
          title: 'Мгновенно',
          text: 'Не нужно открывать приложение — бот доступен там, где вы уже работаете.',
        },
      ],
      messages: [
        { id: 1, from: 'user',  text: 'Создай категорию «Разработка»' },
        { id: 2, from: 'bot',   text: '✅ Категория «Разработка» создана' },
        { id: 3, from: 'user',  text: 'Добавь проект «Мобильное приложение»' },
        { id: 4, from: 'bot',   text: '✅ Проект добавлен в категорию «Разработка»' },
        { id: 5, from: 'user',  text: 'Создай задачу «Верстка главного экрана»' },
        { id: 6, from: 'bot',   text: '✅ Задача создана и добавлена в проект' },
      ],
    }
  },
}
</script>

<style scoped>
.tg-section {
  background: linear-gradient(135deg, #0F172A 0%, #1E3A8A 100%);
  color: white;
}
.tg-section .section__label {
  background: rgba(255, 255, 255, 0.15);
  color: #93C5FD;
}
.tg-section .section__title {
  color: white;
}
.tg-section__subtitle {
  color: rgba(255, 255, 255, 0.75);
  font-size: 1.0625rem;
  line-height: 1.7;
  margin-bottom: 36px;
  max-width: 480px;
}

.tg-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: center;
}

.tg-features {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.tg-feature {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}
.tg-feature__icon {
  width: 44px;
  height: 44px;
  border-radius: var(--radius-sm);
  background: rgba(255, 255, 255, 0.1);
  color: #93C5FD;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.tg-feature__title {
  display: block;
  font-size: 1rem;
  font-weight: 700;
  color: white;
  margin-bottom: 4px;
}
.tg-feature__text {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.65);
  margin: 0;
  line-height: 1.5;
}

.tg-channel {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-top: 32px;
  padding: 12px 20px;
  border-radius: var(--radius-sm);
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.25);
  color: white;
  font-weight: 600;
  font-size: 0.9375rem;
  text-decoration: none;
  transition: var(--transition);
}
.tg-channel:hover {
  background: rgba(255, 255, 255, 0.2);
}

/* Telegram chat mockup */
.tg-chat {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.35);
  max-width: 380px;
  margin-left: auto;
}
.tg-chat__header {
  background: #2AABEE;
  padding: 14px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.tg-chat__avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.25);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.tg-chat__info {
  display: flex;
  flex-direction: column;
}
.tg-chat__name {
  font-weight: 700;
  font-size: 0.9375rem;
  color: white;
}
.tg-chat__status {
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.8);
}
.tg-chat__body {
  padding: 16px;
  background: #F0F2F5;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.tg-chat__bubble {
  max-width: 80%;
  padding: 10px 14px;
  border-radius: 12px;
  font-size: 0.875rem;
  line-height: 1.4;
}
.tg-chat__bubble--user {
  align-self: flex-end;
  background: #2AABEE;
  color: white;
  border-bottom-right-radius: 4px;
}
.tg-chat__bubble--bot {
  align-self: flex-start;
  background: white;
  color: #0F172A;
  border-bottom-left-radius: 4px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.08);
}

@media (max-width: 900px) {
  .tg-layout {
    grid-template-columns: 1fr;
    gap: 48px;
  }
  .tg-chat {
    margin: 0 auto;
  }
  .tg-section__subtitle {
    max-width: 100%;
  }
}
</style>
